import { Functions } from '../utils/functions';
import Toast from 'light-toast';

export const CustomerService = {
    validate_customer: (token, provider_id, location_id, cardNumber) => {
        return new Promise((resolve, reject) => {
            fetch('https://api.medicareclub.ao/api/provider/validate_customer', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-club-key': token
                },
                body: JSON.stringify({
                    card_number: cardNumber ?? null,
                    provider_id: provider_id,
                    location_id: location_id
                })
            })
            .then((response) => {
                if(response.ok) {
                    return response.json();
                } else {
                    // Functions.error(response.status);
                    if(response.status === 404 || response.status === 400) {
                        Toast.fail('Cartão Invalido.');
                    }
                    reject();
                    throw new Error('Something went wrong');
                }
            })
            .then(async (json) => {
                resolve(json);
            })
            .catch((err) => {
                reject(err);
            });
        });
    },
    set_phone_number: (token, numero_cartao_medicare, phone_number) => {
        return new Promise((resolve, reject) => {
            fetch('https://api.medicareclub.ao/api/provider/setTelephone/' + numero_cartao_medicare, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-club-key': token
                },
                body: JSON.stringify({
                    phone_number: phone_number,
                })
            })
            .then((response) => {
                if(response.ok) {
                    return response.json();
                } else {
                    Functions.error(response.status);
                    reject();
                    throw new Error('Something went wrong');
                }
            })
            .then(async (json) => {
                resolve(json);
            })
            .catch((err) => {
                reject(err);
            });
        });
    }
};